import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Alert, Box, Button, Collapse, Stack } from "@mui/material";

const returnReasonSeverityByStatusDataKey = {
  approved: "success",
  cancelled: "error",
  "for-resubmit": "warning",
  partially_approved: "warning",
  pending_review: "warning",
  rejected: "error",
  resubmitted: "warning",
  saved: "info",
  service_processing: "warning",
  submitted: "warning",
};

const returnReasonTitleByStatusDataKey = {
  approved: "Σχόλια Έγκρισης",
  cancelled: "Λόγοι Ακύρωσης",
  "for-resubmit": "Λόγοι Επιστροφής στον Φορέα",
  partially_approved: "Σχόλια Μερικής Έγκρισης",
  pending_review: "Σχόλια Ελέγχου",
  rejected: "Λόγοι Απόρριψης",
  resubmitted: "Σχόλια Επανυποβολής",
  saved: "Σχόλια Κατάστασης",
  service_processing: "Σχόλια Ελέγχου από την Υπηρεσία",
  submitted: "Σχόλια Υποβολής",
};

const getStatusCommentsText = (statusComments) =>
  statusComments?.toString?.().trim?.() ?? "";

const normalizeStatusDataKey = (statusDataKey) =>
  statusDataKey?.toString?.().trim?.().toLowerCase?.() ?? "";

const getReturnReasonSeverity = (statusDataKey) => {
  const normalizedStatusDataKey = normalizeStatusDataKey(statusDataKey);
  return returnReasonSeverityByStatusDataKey[normalizedStatusDataKey] ?? "info";
};

const getReturnReasonTitle = (statusDataKey) => {
  const normalizedStatusDataKey = normalizeStatusDataKey(statusDataKey);
  return (
    returnReasonTitleByStatusDataKey[normalizedStatusDataKey] ??
    "Σχόλια Κατάστασης"
  );
};

const ReturnReasonsAccordion = ({
  enabled = false,
  statusComments,
  statusDataKey,
  files = [],
  onDownloadFile,
}) => {
  const commentsText = getStatusCommentsText(statusComments);
  const statusFiles = Array.isArray(files) ? files : [];

  if (!enabled || (!commentsText && statusFiles.length === 0)) return null;

  return (
    <Collapse in>
      <Alert
        variant="filled"
        severity={getReturnReasonSeverity(statusDataKey)}
        sx={{
          alignItems: "flex-start",
          "& .MuiAlert-message": {
            width: "100%",
          },
        }}
      >
        <Box sx={{ fontWeight: 900, mb: 0.5 }}>
          {getReturnReasonTitle(statusDataKey)}
        </Box>
        {commentsText && (
          <Box
            sx={{
              fontWeight: 600,
              lineHeight: 1.45,
              overflowWrap: "anywhere",
              whiteSpace: "pre-wrap",
            }}
          >
            {commentsText}
          </Box>
        )}
        {statusFiles.length > 0 && (
          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            flexWrap="wrap"
            sx={{ mt: commentsText ? 1 : 0 }}
          >
            {statusFiles.map((file) => (
              <Button
                key={file.id}
                color="inherit"
                size="small"
                startIcon={<AttachFileIcon />}
                onClick={() => onDownloadFile?.(file)}
                sx={{
                  borderColor: "currentColor",
                  fontWeight: 700,
                  maxWidth: "100%",
                  textTransform: "none",
                }}
                variant="outlined"
              >
                {file.origFName || "Συνημμένο αρχείο"}
              </Button>
            ))}
          </Stack>
        )}
      </Alert>
    </Collapse>
  );
};

export default ReturnReasonsAccordion;
